import { useEffect, useState } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import ToolTip from "../common/ToolTip/ToolTip";
import Spinner from "../common/Spinner/spinner";
import { useDispatch, useSelector } from "react-redux";
import { departmentSelector } from "./selector";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import {
  createDepartment,
  deleteDepartment,
  getDepartmentLists,
  updateDepartment,
} from "./action";

const Departments = () => {
  // redux dispatch initialize
  const dispatch = useDispatch();

  // config use to BaseURL
  const config = useConfiguration();

  // Navigate page
  const navigate = useNavigate();

  // Use Location hook use to get a details
  const location = useLocation();

  // department selector
  const { loadingFlag } = useSelector(departmentSelector);

  // Initailize location state
  const { pageTitle, department, saveTitle } = location.state || "";

  // Department name state
  const [deptName, setDeptName] = useState("");

  // Active check box state
  const [deptIsChecked, setDeptIsChecked] = useState(false);

  // Error department name state
  const [errorDeptName, setErrorDeptName] = useState("");

  // Create Department API CALL
  const CreateDepartment = () => {
    // Check the condition not to enter a department name, showing an error
    if (deptName.length > 0) {
      if (!department) {
        // Create Department params
        const createDeptparams = {
          departmentName: deptName,
          isActive: deptIsChecked,
        };
        dispatch(createDepartment(config.baseUrl, createDeptparams)).then(
          (res) => {
            if (res === "Departments Name Already Exists!") {
            } else {
              // Clear the department name input field
              setDeptName("");
              // Clear the error
              setErrorDeptName("");
              // Clear the check box
              setDeptIsChecked(false);
              // setTimeout(() => {
              //   navigate("/departments-list");
              //   // Clear the department name input field
              //   setDeptName("");
              //   // Clear the error
              //   setErrorDeptName("");
              //   // Clear the check box
              //   setDeptIsChecked(false);
              // }, 1200);
            }
          }
        );
      } else {
        // Update Department params
        const updateDeptParams = {
          candidateDepartmentId: department.candidateDepartmentId,
          departmentName: deptName,
          isActive: deptIsChecked,
        };
        dispatch(updateDepartment(config.baseUrl, updateDeptParams)).then(
          () => {
            setTimeout(() => {
              navigate("/departments-list");
              // Clear the department name input field
              setDeptName("");
              // Clear the error
              setErrorDeptName("");
              // Clear the check box
              setDeptIsChecked(false);
            }, 1200);
          }
        );
      }
    } else {
      // Error message
      setErrorDeptName("This field is required");
    }
  };

  useEffect(() => {
    if (department) {
      setDeptName(department.departmentName);
      setDeptIsChecked(department.isActive);
    }
  }, [department]);

  // While Click the cancel button clear the form elements
  const CancelDepartment = () => {
    if (!department) {
      // Clear the department name input field
      setDeptName("");
      // Clear the error
      setErrorDeptName("");
      // Clear the check box
      setDeptIsChecked(false);
    } else {
      navigate("/departments-list");
    }
  };

  return (
    <>
      {loadingFlag > 0 && <Spinner />}
      <Header />
      <Sidebar />
      <div className="page main-margin">
        <div className="page-main">
          <div className="main-content app-content mt-0 main-background">
            <div className="side-app">
              <div className="main-container container-fluid">
                <div className="page-header">
                  {
                    <h1 className="page-title">
                      {pageTitle ? pageTitle : "Create Department"}
                    </h1>
                  }
                </div>

                <div class="card">
                  <div class="card-body">
                    <div class="panel panel-primary">
                      <input
                        className="form-control w-50"
                        placeholder="Enter Department"
                        value={deptName}
                        onChange={(e) => setDeptName(e.target.value)}
                      />
                      {errorDeptName && (
                        <span className="text-danger mx-1">
                          {errorDeptName}
                        </span>
                      )}
                      <div className="mt-2 mx-1">
                        <input
                          type="checkbox"
                          name="isActive"
                          checked={deptIsChecked}
                          onChange={(e) => setDeptIsChecked(!deptIsChecked)}
                        />
                        Active
                      </div>
                      <div className="d-flex gap-2 justify-content-end">
                        <button
                          className="btn btn-primary"
                          onClick={CreateDepartment}
                        >
                          {saveTitle ? saveTitle : "Add"}
                        </button>
                        <button
                          className="btn btn-outline-primary"
                          onClick={CancelDepartment}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Departments;
